import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Alert, Spinner, Table } from "reactstrap";
import periodosLetivos, {
  PeriodosLetivosResponse,
} from "../../api/periodosLetivos";
import { errorToString } from "../../helpers/funcoes";
import { Titulo } from "../Titulo";

function formatDate(value?: string) {
  if (!value) return "-";
  const date = moment(value);
  if (!date.isValid()) return "-";
  return date.local().format("DD/MM/YYYY");
}

export function PeriodosLetivosLista() {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<PeriodosLetivosResponse[]>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    setLoading(true);
    periodosLetivos
      .getAll()
      .then((res) => setItems(res))
      .catch((err) => setError(errorToString(err)))
      .finally(() => setLoading(false));
    return () => setItems(undefined);
  }, []);

  const onDelete = (
    e: React.MouseEvent<HTMLAnchorElement>,
    nome: string,
    id: string,
  ) => {
    e.preventDefault();

    if (!confirm(`Deseja realmente excluir o período letivo "${nome}"?`)) {
      return;
    }

    setLoading(true);
    setError(undefined);

    periodosLetivos
      .remove(id)
      .then(() => periodosLetivos.getAll().then((res) => setItems(res)))
      .catch((err) => setError(errorToString(err)))
      .finally(() => setLoading(false));
  };

  if (loading) {
    return (
      <div className="text-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div>
      <Titulo text="Períodos letivos" />
      {error && (
        <Alert color="danger" data-cy="alert">
          {error}
        </Alert>
      )}
      <div className="text-end">
        <Link to="form">Adicionar</Link>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Início</th>
            <th>Fim</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {items?.map((i) => (
            <tr key={i.id}>
              <td>{i.nome}</td>
              <td>{formatDate(i.startAt)}</td>
              <td>{formatDate(i.endAt)}</td>
              <td className="text-end">
                <Link to={`form/${i.id}`} data-cy={`edit`}>
                  {" "}
                  <FaEdit />
                </Link>
                &nbsp; &nbsp;
                <Link
                  to={`./`}
                  onClick={(e) => onDelete(e, i.nome, i.id)}
                  data-cy={`delete`}
                >
                  <FaTrash />
                </Link>
              </td>
            </tr>
          )) ?? (
            <tr>
              <td colSpan={4} className="text-center">
                Nenhum período letivo encontrado.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}
